import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(shop)/become-a-reseller/page.tsx");
